import type { OwaDate } from '../../../schema';
import { GlobalCalendarLocale, GlobalCalendarLanguage } from '../../../intl/globalCalendarLocale';
import getIntlYearBase from '../base/getIntlYearBase';
import convertNumberToHebrew from './convertNumberToHebrew';

export default function getIntlYearHebrew(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    const result = getIntlYearBase(date, locale, format);

    if (locale.calendarLanguage == GlobalCalendarLanguage.Hebrew) {
        // Convert to Hebrew numerals
        return convertNumberToHebrew(Number(result));
    }

    return result;
}
